import React, { Component } from 'react'
import Select, { Creatable, Async } from 'react-select';
import classNames from 'classnames';
import { SingleDatePicker } from 'react-dates'
import moment from 'moment';
import Switch from "react-switch";
import { api } from 'api';


let TIPO_MOVIMIENTOS = [
    {id: 1, value: 1, label:"Ingreso"},
    {id: 2, value: 2, label:"Egreso"},
]

const getTipoMovimientos = (e) => {
    const params = {};
    if (e) params.search = e;

    return api.get("inventario-transicion/get_tipo_movimientos", params).
        then((data) => {
            if (data) return data.results;
            return [];
        }).catch(() => {
            return [];
        });
};


export default class ToolbarMovimientos extends Component {

    state = {
        dateStart: moment.now(),
        focusedStart: false,

        dateEnd: moment.now(),
        focusedEnd: false,
    }

    componentWillMount(){
    }

    format = (array=[]) =>{
        const nuevoArray = [];
        array.forEach((item,index) => {
            nuevoArray[index]={"label": item.nombre , "value": item.id}
        });
        return nuevoArray
    }

    handleChangeBodegaKardex = (value) => {
        this.props.setEsBodegaPM(value, this.props.id_bodega);
    }

    handleChangeKardexTransicionTipo = (e) => {
        this.props.changeKardexTipoMovimiento(e, this.props.id_bodega)
    }

    changeOrigenMovimientoSelect = (e) => {
        this.props.changeOrigenMovimiento(e, this.props.id_bodega)
    }

    render() {
        const {
            mostrarBodegasVirtuales,
            changeUsuario,
            changeUsuarioTransicion,
            changeTipoTransicion,
            setDateStartTransicion,
            setDateEndTransicion,
            usuarios,
            changeTipo,
            tipos,
            id_bodega
        } = this.props;

        return (
            <div className="row col-12 p-0 m-0">

                {mostrarBodegasVirtuales && (
                    <div className="row col-12 p-0 m-0 align-self-center">
                        <div className="col-3">
                            <div className="d-flex justify-content-center align-items-center h-50">
                                <label className="t-azul" htmlFor="bodega_transicion">Bodega MP / Bodega Producción</label>
                            </div>
                            <div className="d-flex justify-content-center align-items-center h-50">
                                <Switch
                                    onColor="#0a5995"
                                    offColor="#ccc"
                                    onChange={(value) => {
                                        this.handleChangeBodegaKardex(value);
                                    }}
                                    checked={this.props.es_bodega_mp}
                                    id="normal-switch"
                                />
                            </div>
                        </div>

                        <div className="col-3">
                            <label className="t-azul" htmlFor="tipo_movimiento">Tipo Movimiento</label>
                                <Select
                                    isClearable={true}
                                    className={classNames('react-select-container')}
                                    backspaceRemovesValue={false}
                                    isSearchable={true}
                                    options={TIPO_MOVIMIENTOS}
                                    placeholder={"Movimiento"}
                                    value={this.props.valorMovimiento}
                                    onChange={this.handleChangeKardexTransicionTipo}
                                    />
                        </div>

                        <div className="col-3">
                            <span className="t-azul-claro font-weight-bold">ORIGEN MOVIMIENTO</span>
                            <Async
                                isClearable={true}
                                backspaceRemovesValue={false}
                                isSearchable={true}
                                defaultOptions={true}
                                loadOptions={(e) => getTipoMovimientos(e)}
                                getOptionValue={(option) => (option["id"])}
                                getOptionLabel={(option) => (option["label"])}
                                type="text"
                                multi={true}
                                autoload={false}
                                cache={false}
                                className={classNames('react-select-container ')}
                                placeholder="Seleccionar.."
                                onChange={(e) => {
                                    this.changeOrigenMovimientoSelect(e);
                                }}
                            />
                        </div>

                        {/*
                        <div className="col-3">
                            <label className="t-azul" htmlFor="no_despacho">No Despacho</label>
                            <Select
                                isClearable={true}
                                className={classNames('react-select-container')}
                                backspaceRemovesValue={true}
                                isSearchable={true}
                                options={this.format(tipos? tipos:[])}
                                placeholder={"Tipo producto"}
                                // value={null}
                                onChange={(e, action)=>{console.log(e, action); changeTipo(e, id_bodega)}}
                            />
                        </div>
                        */}
                    </div>
                )}

                <div className={"col-lg-3 col-md-3 col-12 align-self-center"}>
                        <SingleDatePicker
                        className="form-control"
                        placeholder={"Fecha Inicio"}
                        date={this.props.dateStart ? moment(this.props.dateStart ) : null}
                        focused={this.state.focusedStart}
                        isOutsideRange={() => false}
                        onDateChange={(value) => {
                        this.setState({dateStart:value})
                            mostrarBodegasVirtuales ?
                                setDateStartTransicion(value, id_bodega)
                                :
                        this.props.setDateStart(value, id_bodega)
                        }}
                        onFocusChange={({ focused }) => this.setState({ focusedStart: focused })}
                        numberOfMonths={1}
                        id={"dateStart"}
			            readOnly = { true }
                    />
                    </div>
                    <div className={"col-lg-3 col-md-3 col-12 align-self-center"}>
                        <SingleDatePicker
                        className="form-control"
                        placeholder={"Fecha Final"}
                        date={this.props.dateEnd ? moment(this.props.dateEnd ) : null}
                        focused={this.state.focusedEnd}
                        isOutsideRange={() => false}
                        onDateChange={(value) => {
                           this.setState({dateEnd:value})
                            mostrarBodegasVirtuales ?
                                setDateEndTransicion(value, id_bodega)
                                :
                           this.props.setDateEnd(value, id_bodega);
                        }}
                        onFocusChange={({ focused }) => this.setState({ focusedEnd: focused })}
                        numberOfMonths={1}
                        id={"dateStart"}
			            readOnly = { true }
                    />
                    </div>
                <div className="col-3 p-2 m-0 ">
                    <Select
                        isClearable={true}
                        className={classNames('react-select-container')}
                        backspaceRemovesValue={true}
                        isSearchable={true}
                        options={this.format(usuarios? usuarios:[])}
                        placeholder={"Usuario"}
                        // value={null}
                        onChange={(e, action)=>{
                            mostrarBodegasVirtuales ?
                                changeUsuarioTransicion(e, id_bodega)
                                :
                                changeUsuario(e, id_bodega);
                        }}
                    />
                </div>
                <div className="col-3 p-2 m-0 ">
                    <Select
                        isClearable={true}
                        className={classNames('react-select-container')}
                        backspaceRemovesValue={true}
                        isSearchable={true}
                        options={this.format(tipos? tipos:[])}
                        placeholder={"Tipo producto"}
                        // value={null}
                        onChange={(e, action)=>{
                            mostrarBodegasVirtuales ?
                                changeTipoTransicion(e, id_bodega)
                                :
                                changeTipo(e, id_bodega)
                        }}
                    />
                </div>
            </div>
        )
    }
}